import {
  AbstractControl,
  ValidationErrors,
} from '@angular/forms';

export class GonvarriCustomFormValidators {

  public static MIN_PASSWORD_LENGHT = /^.{7,}$/

  static passwordValidator(control: AbstractControl): ValidationErrors | null {
    const password = control.value as string;
    return password && (!password.length || password.match(GonvarriCustomFormValidators.MIN_PASSWORD_LENGHT))
      ? null
      : { cxInvalidPassword: true };
  }

  static passwordValidators = [
    this.passwordValidator,
  ];

}
